import {ref} from "vue";
import load from "@/common/load";
import tagStore from "@/stores/tagStore";

/**
 *@Author  ahuan
 *@Description
 *@Date 2024/6/17
 **/
export default function () {
    let randomHexColor = () => {
        // 生成一个 0 到 16777215 之间的随机整数（16进制颜色代码的上限）
        var randomColor = Math.floor(Math.random() * 16777215).toString(16);

        // 确保生成的颜色代码始终是 6 位长度
        return '#' + randomColor.padStart(6, '0');
    }

    let tag = tagStore();
    //设备id
    let devId = ref("");
    // 查找设备方法
    let searchDev = () => {
        console.log(tag.currentFilterListInfo)
        if(Object.keys(tag.currentFilterListInfo).length === 0) return load.error("设备列表为空...")
        let filredList = tag.currentFilterListInfo.devices.filter(v=>{
            return devId.value === '' || v.uniqueCode.includes(devId.value)
        })
        let online = 0;
        filredList.forEach((item) =>{
            if(item.online === 1){
                online++
            }
        });
        tag.currentTagListInfo.online = online;
        tag.currentTagListInfo.total = filredList.length;
        tag.currentTagListInfo.devices = filredList;
    }

    let activeKey = ref("1")
    return {
        randomHexColor,
        devId,
        searchDev,
        activeKey
    }
}
